<template>
  <div class="inputSearch">
     <input type="text" class="inputSear"  v-model="inputText" ref="ipt"
      :placeholder="setPlaceholder"
      :style="{width:setWidth,height:height,}"
      @focus="focusInput"
      @keydown="keydown($event)"
      @input="getInputVal(inputText)"
      @blur="blurInput"
      @click="RecentShow"
      />
      <div v-show="isShow != 3" class="dataBox" style="width:246px;max-height:400px" id="StartCityeara" >
        <div v-show="isShow == 0">
          <div class="Recent"> My Records</div>
          <div  style="text-align: center;padding: 5px;" v-show="!Recent.length">No result</div>
          <el-scrollbar style="height:100%;min-width:246px">        
            <ul style="max-height: 200px" v-show="Recent.length">
              <li class="es" v-for="(item,index) in Recent" :key="index" @click="getText(item)" :class="{isActive:index==isIndex}" 
                @mouseover="clearKeydown(index)">{{item.CityNameEn}},{{item.Province_NameEn}}</li>
            </ul>
          </el-scrollbar>
        </div>
        <div v-show="isShow != 0">
          <div class="Recent"> Origin City</div>
          <el-scrollbar style="height:100%;">        
            <ul v-show="isShow == 1" style="max-height: 300px">
              <li class="es" v-for="(item,index) in queryList" :key="index" @click="getText(item)" :class="{isActive:index==isIndex}" 
                @mouseover="clearKeydown(index)">{{item.CityNameEn}},{{item.Province_NameEn}}</li>
            </ul>
            <ul v-show="isShow == 2">
              <div  style="text-align: center;padding: 5px;">No result</div>
            </ul>
          </el-scrollbar>
        </div>
        <!-- 模糊搜索 end -->
      </div>
  </div>
</template>
<script>
import Vue from "vue";
import bus from '@/ask/eventBus';
import { post, fetch, Del, put } from "@/ask/axios";
  export default {
    props: {
       setPlaceholder: { type: String }, //输入框默认值
       setWidth: { type: String }, //宽度
       height: { type: String }, //高度
       Recent: {type: Array} , //最近列表
       setData: {type: Object} , // 
    },
    data () {
      return {
        api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      isShow:3, //0是否显示最近查询 1:数据显示，2：数据无结果显示 3.不显示
      inputFocus: true, //聚焦
      inputText:'',//输入
      disappear:true,
      key:"",
      queryList:[],
      isIndex:-1,
      curList:'',//当前list

      }
    },
    created() {
      //console.log("初始化的值====",this.Recent,this.queryList);
    },
    mounted(){
      document.addEventListener('click',(e) => {
        if(!this.inputFocus) {
          var sp = document.getElementById("StartCityeara");
          if(sp && !sp.contains(e.target)) {
            this.isShow=3
          }
        }
      })
      setTimeout(()=>{
        if(JSON.stringify(this.setData) !== "{}") {
          this.curList = this.setData
          var  curText = `${this.curList.CityNameEn},${this.curList.Province_NameEn}`
          this.inputText = curText;
          this.$emit('byCityValue',this.curList) 
        }
      },500)
    },

    computed: { //计算属性函数
     },
    methods: {
      // 聚焦
      focusInput:function(e) {
        this.isShow = 0
        this.inputFocus = true
        this.$refs.ipt.select(); // or e.currentTarget.select();
      },

      //货物input输入框输入值
      getInputVal(){
        this.searchCity(); //搜索数据接口
      },

      RecentShow() {
        if(this.isShow == 3) {
          this.isShow = 0
        }
      },

      //鼠标移入时清除键盘事件
      clearKeydown(index){
        this.isIndex = index;
      },

      // 键盘方法
      keydown(e){
         let showList = ''
        if(this.isShow == 0 ) {
          showList=this.Recent.length
        } else {
          showList=this.queryList.length
        }
        if (e.keyCode == 40) {//下键
          this.isIndex++;
          if (this.isIndex > showList-1) {
             this.isIndex = 0;
          }
        } else if (e.keyCode == 38) {//上
          this.isIndex--;
          if (this.isIndex < 0) {
            this.isIndex = showList - 1;
          }
        } else if (e.keyCode == 13) {//回车
         let text = document.querySelector('.isActive');
          if(this.isIndex >= 0) {
            if(this.isShow == 0 ) {
              this.curList = this.Recent[this.isIndex]
            } else {
              this.curList = this.queryList[this.isIndex]
            }
            var  curText = `${this.curList.CityNameEn},${this.curList.Province_NameEn}`
            this.inputText = curText;
            this.isShow=3
            this.disappear = false
            this.$emit('byCityValue',this.curList) 
          }
          this.isIndex = -1;
        }
      },

      //列表点击事件
      getText(item){
        var  curText = `${item.CityNameEn},${item.Province_NameEn}`
        this.inputText= curText; //text赋值
        this.curList = item
        this.isShow=3 //关闭下拉框
        this.disappear = false
        this.$emit('byCityValue',item) 

       //传值到父组件
      },
      blurInput(){
        // 延迟等待getText事件
        this.inputFocus = false
        this.disappear = true
        setTimeout(()=>{
          var  curText = `${this.curList.CityNameEn},${this.curList.Province_NameEn}`
          //console.log(this.inputText, curText ,this.inputText != curText,"44" )
          if(this.inputText != curText && this.disappear){
            this.inputText = ''
            this.curList = ''
          }
          // this.isShow = 3
          this.$emit('byCityValue',this.curList) 
        },200)
      },

      // +++++++++接口++++++++++
      
      searchCity(){
        this.api.param={
          provinceName:this.inputText,
          cityName:this.inputText,
          take:10
        }
        this.api.url=this.$api02+"/api/EbayCustomer/City/GetCityLikeName"
        fetch(this.api.url,this.api.param).then((res)=>{
          //console.log(res)
          if(res.Results){
            //console.log("返回的什么值",res.Results);
            if(res.Results.length > 0){               
              this.queryList = res.Results 
              this.isShow = 1             
            } else {
              this.isShow = 2
            }
          }          
        });
      },
    },
  }
</script>
<style lang="css" scoped>
.inputSearch{position: relative;}
.inputSear{border:1px solid #ddd;border-radius:5px;padding:0 5px;}
.dataBox{ background:#fff;border:1px solid #eee;border-radius:5px;position:absolute;top:31px;left:0px;z-index:66;
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);-webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);}
  .dataBox ul li{cursor: pointer;color:#888;line-height:30px;padding: 0 5px}
  .dataBox ul li:hover{background:#f5f7fa}
  .Recent{ font-weight:700; padding-left:6px;line-height:30px;background:#f5f5f5;}
.isActive{background-color: #f5f7fa !important;}
.es{overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
  .sepTipsMsg{color:#999;text-align:center;}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/air/component/startCityeara.vue